<div class="sale-requests">


  <div class="row mt-4 mb-2">
    <div class="col-md-11 col-sm-12 text-center">

        <button
          type="button"
          class="btn btn-outline-primary me-1 btn-sm"
          (click)="onClickTab('requested')"
          [ngClass]="{ active: requestTab === 'requested' }"
        >
          In Review ({{ getRequestedCount() }})
        </button>
        <!--<button
          type="button"
          class="btn btn-outline-primary me-1 btn-sm"
          (click)="onClickTab('invited')"
          [ngClass]="{ active: requestTab === 'invited' }"
        >
          Invited ({{ getInvitedCount() }})
        </button>-->
        <button
          type="button"
          class="btn btn-outline-primary me-1 btn-sm"
          (click)="onClickTab('denied')"
          [ngClass]="{ active: requestTab === 'denied' }"
        >
          Denied ({{ getDeniedCount() }})
        </button>
        <button
          type="button"
          class="btn btn-outline-primary me-1 btn-sm"
          (click)="onClickTab('approved')"
          [ngClass]="{ active: requestTab === 'approved' }"
        >
          Approved ({{ getApprovedCount() }})
        </button>
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="onClickTab('all')"
          [ngClass]="{ active: requestTab === 'all' }"
        >
          All ({{ _saleMemberRequests?.length }})
        </button>
    </div>
  </div>
  <div
    *ngIf="_tab === saleTabs.REQUESTS"
    class="table-responsive data-grid sticky-header-table sticky-header-table-height-md"
  >
    <table  mat-table="matTable"
           [dataSource]="dataSource"
           #matTable
           class="table table-hover"
           matSort="requestSort"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="table"
           [fromRoot]="true"
           (scrolled)="onTableScroll()"
           [trackBy]="trackById">
      <ng-container matColumnDef="memberName">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-6-rem h6 text-dark"
          *matHeaderCellDef
        >
          <strong>Vet <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.memberName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="clinic">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-6-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.CLINIC_NAME)"
          *matHeaderCellDef
        >
          <strong>Clinic <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.clinic }}
        </td>
      </ng-container>

      <ng-container matColumnDef="emailAddress">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-6-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.EMAIL)"
          *matHeaderCellDef
        >
          <strong>Email <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.emailAddress }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-6-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.PHONE)"
          *matHeaderCellDef
        >
          <strong>Phone <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          <a href="tel:{{ element.mobile }}">{{ element.mobile }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-6-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.DATE_TIME)"
          *matHeaderCellDef
        >
          <strong>Date/Time <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdDate | date : "dd MMM yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="access">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-4-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.ACCESS)"
          *matHeaderCellDef
        >
          <strong>Access <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          <strong class="text-primary">{{ getAccess(element) }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-4-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.STATUS)"
          *matHeaderCellDef
        >
          <strong>Status <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.saleMemberStatusId === 5"
            class="study-status-box study-status-box-0"
            >{{ element.saleMemberStatusName }}</span
          >
          <span
            *ngIf="element.saleMemberStatusId === -1"
            class="study-status-box study-status-box-1"
            >{{ element.saleMemberStatusName }}</span
          >
          <span
            *ngIf="element.saleMemberStatusId === -2"
            class="study-status-box study-status-box-1"
            >{{ element.saleMemberStatusName }}</span
          >
          <span
            *ngIf="element.saleMemberStatusId === 4"
            class="study-status-box study-status-box-3"
            >{{ element.saleMemberStatusName }}</span
          >
          <span
            *ngIf="element.saleMemberStatusId === 3"
            class="study-status-box study-status-box-4"
            >{{ element.saleMemberStatusName }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="comments">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-7-rem h6 text-dark"
          (click)="sortTable(saleRequestsTableFields.COMMENT)"
          *matHeaderCellDef
        >
          <strong>Comment <i class="fa fa-sort ms-1"></i></strong>
        </th>
        <td mat-cell *matCellDef="let element" [class]="element.saleMemberStatusId === 4 ? 'text-danger' : 'text-success'">
          {{ element.comments }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-sort-header
          mat-header-cell
          class="cursor-pointer w-3-rem h6 text-dark"
          *matHeaderCellDef
        >
          <strong>Action</strong>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
        >
        <button type="button" class="btn btn-warning btn-sm" (click)="ReviewVetInfo(element)" *ngIf="!(element.saleMemberStatusId === -2 || element.saleMemberStatusId === -1)">Review</button>         
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="
          let row;
          columns: displayedColumns$.value;
          let saleIndex = index
        "
        class="border-start-0 border-end-0 pointer"
      ></tr>
    </table>
  </div>
</div>
